import { createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";
import { landingpage } from "../model/landingpage";
import { landingpageFailure, landingpageViewFailure, saveLandingpage, viewLoadLandingPage, viewSuccessLandingpage } from "../action/landingpage.action";

export interface landingpageState{
    landingpage:landingpage[];
    error:String | null;
}
export const initailState:landingpageState={
    landingpage:[],
    error:null
}
export const landingpageReducer=createReducer(
    initailState,
   on(saveLandingpage,(state,{landingpage})=>{
    console.log(landingpage,'landingpage')
    if(landingpage.id==null || landingpage.id==undefined || landingpage.id=="") {
        return {
            ...state,
            landingpage:[...state.landingpage,landingpage]
        }
    }else{
        const newState=state.landingpage.map((lp:any)=>lp.id==landingpage.id ?{ ...landingpage }:lp)
        return{
            ...state,
            landingpage:newState
        }
    }
   }),


   on(landingpageFailure,(state,{error})=>({...state,error})),
    on(viewLoadLandingPage,(state)=>({...state})),
//    on(viewSuccessLandingpage,(state,{landingpage})=>({...state,landingpage:[...state.landingpage,landingpage]})),
    on(landingpageViewFailure, (state, { error }) => ({ ...state, error })),
    on(viewSuccessLandingpage, (state, { landingpage }) => ({
        ...state,
        landingpage
      })),
)

export const selectLandingPageState = createFeatureSelector<landingpageState>('landingpage');
export const selectLandingPageData = createSelector(
    selectLandingPageState,
    (state) => state.landingpage
  );
